// Components
export { ShippingListing } from './components/shipping-listing';
export { ShippingAssignPage } from './components/shipping-assign-page';
export { ShippingDetailPage } from './components/shipping-detail-page';
export { ShippingFormDialog } from './components/shipping-form-dialog';
export { ShippingStatusBadge } from './components/shipping-status-badge';
export { ShippingPriorityTag } from './components/shipping-priority-tag';

// Services
export {
  useCreateShipmentMutation,
  useUpdateShipmentMutation,
  useDeleteShipmentMutation,
  useChangeShipmentStatusMutation,
  useAssignBoxesMutation,
  useConfirmShipmentMutation,
  useDispatchShipmentMutation,
  useSaveDraftMutation,
  useBulkDeleteShipmentsMutation,
  useBulkChangeStatusMutation
} from './services/shipping.mutations';

export { shippingQueries, shipmentKeys } from './services/shipping.queries';

// Types
export type {
  Shipment,
  ShipmentMetrics,
  ShipmentPriority,
  ShipmentStatus,
  CreateShipmentRequest,
  UpdateShipmentRequest,
  AssignBoxesRequest,
  ShipmentsListParams
} from './types';
